import app from 'flarum/forum/app';
let promise = null;

/** Load (once) and return all statuses sorted by position. */
export function loadStatuses() {
  if (!promise) {
    promise = app.store.find('nh-statuses').then(() => allStatuses());
  }
  return promise;
}
export function allStatuses() {
  return app.store.all('nh-statuses').slice().sort((a, b) => a.position() - b.position() || Number(a.id()) - Number(b.id()));
}
export function usableStatuses() {
  return allStatuses().filter(s => s.canUse());
}
flarum.reg.add('neverhack-forum-nodes', 'forum/utils/statuses', { loadStatuses: loadStatuses,allStatuses: allStatuses,usableStatuses: usableStatuses, });